import { Skeleton } from "primereact/skeleton"

export function PreceptorFeedbackScore({ label, value, isLoading }) {
    return (
        <div className="d-flex flex-lg-stack flex-lg-row flex-column py-6 gap-4">
            <div className="d-flex align-items-center me-3 w-100 w-lg-50">
                <div className="fs-5 fw-bold">{label}</div>
            </div>
            <div className="d-flex align-items-center w-100 w-md-50">
                {isLoading ? (
                    <Skeleton width="100%" height="8px" />
                ) : (
                    <>
                        <div className="progress h-8px w-100 me-2 bg-secondary">
                            <div
                                className="progress-bar bg-primary"
                                role="progressbar"
                                style={{ width: `${value ?? 0}%` }}
                            />
                        </div>
                        <span className="text-dark fs-5 fw-bold">
                            {value == null ? "N/A" : `${value}%`}
                        </span>
                    </>
                )}
            </div>
        </div>
    )
}
